import { GmailIcon, OutlookIcon } from "src/assets/icons";
import {
  SubmitSuccessContainer,
  EmailClientRow,
  EmailClientItemContainer,
  EmailClientItemImage,
  EmailClientItemText,
} from "./SubmitSuccess.styles";

const EmailClientItem = ({ icon, text, href }) => (
  <EmailClientItemContainer
    href={href}
    target="_blank"
    rel="noopener noreferrer"
  >
    <EmailClientItemImage>{icon}</EmailClientItemImage>
    <EmailClientItemText>{text}</EmailClientItemText>
  </EmailClientItemContainer>
);

export const SubmitSuccess = ({ resendMagicLink }) => (
  <SubmitSuccessContainer>
    <EmailClientRow>
      <EmailClientItem
        href="https://mail.google.com/mail/u/0/#inbox"
        icon={<GmailIcon />}
        text="Open Gmail"
      />
      <EmailClientItem
        href="https://outlook.office.com/mail/inbox"
        icon={<OutlookIcon />}
        text="Open Outlook"
      />
    </EmailClientRow>
    <div>
      Didn't receive an email? Try checking your junk folder.{" "}
      <a onClick={resendMagicLink}>Resend magic link</a>.
    </div>
  </SubmitSuccessContainer>
);
